module.exports = ":host ::ng-deep .ngx-datatable .datatable-body .datatable-scroll {\n  display: inherit; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-show-forklift/master-show-forklift.component.scss
// module id = ./src/app/master/master-show-forklift/master-show-forklift.component.scss
// module chunks = main